

import { Instance, types } from 'mobx-state-tree';
import { MetadataModel } from './MetadataModel';

export const AnswerModel = types.model('AnswerModel', {
  _id: types.string,
  key: types.maybeNull(types.string),
  nextKey: types.maybeNull(types.string),
  wording: types.maybeNull(types.string),
  featureChoice: types.maybeNull(types.string),
  specialTypeOfAnswer: types.maybe(types.boolean),
  meta: types.maybeNull(types.array(MetadataModel)),
});


export type IAnswerModel = Instance<typeof AnswerModel>;